<template>
  <div
    class="modal fade"
    id="ModalEditBlockIP"
    tabindex="99"
    role="dialog"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-notify modal-info" role="document">
      <!--Content-->
      <div class="modal-content text-center">
        <!--Header-->
        <div class="modal-header d-flex justify-content-center">
          <p class="heading">ویرایش ip در لیست مسدود شده ها</p>
        </div>

        <!--Body-->
        <div class="modal-body px-4 py-2">

          <!-- کادر ip کاربر -->
          <div class="position-relative">
            <input
              type="text"
              placeholder="ip کاربر"
              class="form-control text-center mt-2"
              v-model="EditBlockIPData.UserIP"
              autocomplete="off"
              style="direction: ltr;"
            />
            <i class="fas fa-user fa-1x-half position-absolute" style="right: 8px; top: 33%;"></i>
          </div>

          <!-- کادر مدت مسدود شدن -->
          <div class="position-relative">
            <select
              class="form-control mt-1 text-center"
              v-model="EditBlockIPData.BlockIPTime"
            >
              <option value="0">مدت مسدود شدن را انتخاب نمایید</option>
              <option value="5">5 دقیقه</option>
              <option value="10">10 دقیقه</option>
              <option value="15">15 دقیقه</option>
              <option value="60">1 ساعت</option>
              <option value="120">2 ساعت</option>
              <option value="300">5 ساعت</option>
              <option value="600">10 ساعت</option>
              <option value="1440">1 روز</option>
              <option value="2880">2 روز</option>
              <option value="-1">دائمی</option>
            </select>
            <i class="far fa-building fa-1x-half position-absolute" style="right: 9px; top: 33%;"></i>
          </div>
        </div>

        <!--Footer-->
        <div class="modal-footer flex-center px-4">
          <a
            class="btn btn-info waves-effect waves-light"
            v-bind:class="checkConnectToServer ? 'disabled btn-pink': ''"
            v-on:click="SaveEditBlockIPData()"
            >
            <i v-if="checkConnectToServer" class="fas fa-sync fa-spin fa-1x ml-2"></i>
            ویرایش ip
            </a>
          <a
            class="btn btn-outline-info waves-effect waves-light"
            v-bind:class="checkConnectToServer ? 'disabled': ''"
            style="padding-top: 0.375rem; padding-bottom: 0.375rem"
            data-dismiss="modal"
          >انصراف</a>
        </div>
      </div>
      <!--/.Content-->
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
        EditBlockIPData:{ 
          ID: 0, 
          UserIP: '', 
          BlockDate: '', 
          CountError: 0, 
          BlockIPTime: 0,
          ActiveStatus: true
        }
        ,
      // کنترل وضعیت اتصال به سرور
      checkConnectToServer: false,
    };
  },
  props: ['BlockIPData'],
  methods: {
    // دریافت اطلاعات آی پی
    getBlockIPData() {
      this.EditBlockIPData.ID = this.BlockIPData.ID;
      this.EditBlockIPData.UserIP = this.BlockIPData.UserIP;
      this.EditBlockIPData.BlockDate = this.BlockIPData.BlockDate;
      this.EditBlockIPData.CountError = this.BlockIPData.CountError;
      this.EditBlockIPData.BlockIPTime = this.BlockIPData.BlockIPTime;
      this.EditBlockIPData.ActiveStatus = this.BlockIPData.ActiveStatus;
    },
    // ذخیره تغییرات مسدودسازی آی پی
    async SaveEditBlockIPData() {
      // آیا آی پی کاربر مقدار دهی شده است ؟
      if(this.EditBlockIPData.UserIP != ''){
        // آیا مدت مسدود شدن ثبت شده است ؟
        if(this.EditBlockIPData.BlockIPTime != 0){
          // اعلام اتصال به سرور
          this.checkConnectToServer = true;
          // دریافت توکن احراز هویت
          let token = await this.$store.getters.getUserData.token;
          // تاریخ ثبت
          // جهت رفع خطای نوع داده تاریخ در ارسال
          this.EditBlockIPData.BlockDate = new Date().toISOString();
          this.EditBlockIPData.ActiveStatus = true;
          // ثبت اطلاعات کاربر در سرور
          var check = await this.$store.dispatch("EditBlockIPToServer", {
            EditBlockIPData: this.EditBlockIPData,
            token: token,
          });
          if (check == true){
            // آی پی مورد نظر به لیست اضافه شد
            this.$store.dispatch("notify", {
              notText: "ip مورد نظر با موفقیت به لیست اضافه شد .",
              timeOut: 2500,
            });

            // بستن مودال ثبت آی پی کاربر
            $("#ModalEditBlockIP").modal("hide");
          }
        } else {
          // ثبت مدت مسدود شدن الزامی است
          this.$store.dispatch("notify", {
            notText: "عدم درج مدت مسدود شدن : درج مدت مسدود شدن الزامی است !",
            timeOut: 2500,
          });
        }
      } else {
        // ثبت آی پی کاربر الزامی است
        this.$store.dispatch("notify", {
          notText: "عدم درج ip : درج ip کاربر الزامی است !",
          timeOut: 2500,
        });
      }
      // اعلام اتمام اتصال به سرور
      this.checkConnectToServer = false;
    },

  },
  watch: {
    BlockIPData: function(value){
      this.getBlockIPData();
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/pages/AdminPanel/Components/ManageBlockIP/Components/EditBlockIP.vue